import React from 'react';
import { Link } from 'react-router-dom';
import SystemsHeader from '../../components/SystemsHeader';
import SystemsFooter from '../../components/SystemsFooter';
import SeoHead from '../../components/SeoHead';
import { useSystemsCatalog } from '../../context/SystemsCatalogContext';
import { useCurrency } from '../../context/CurrencyContext';
import { ArrowRight } from 'lucide-react';

export default function AllPricing() {
  const { services, orderedSlugs, loading } = useSystemsCatalog();
  const { format } = useCurrency();

  return (
    <div className="min-h-screen bg-white">
      <SeoHead path="/systems/pricing" title="All Pricing — ZHELTA Systems" description="Transparent pricing across every ZHELTA Systems service. Pick a plan that fits your business." />
      <SystemsHeader />
      <main className="py-20 md:py-28">
        <div className="zh-container max-w-6xl">
          <div className="text-center mb-14">
            <span className="inline-block text-[11px] font-extrabold uppercase tracking-[0.2em] text-[#c9a227]">Transparent Pricing</span>
            <h1 className="mt-4 text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight text-gray-900 leading-[1.05]">All ZHELTA Systems <span className="text-[#f5a623]">Pricing</span></h1>
            <p className="mt-6 text-[17px] text-gray-600 max-w-2xl mx-auto leading-relaxed">Every service at a glance — starting prices shown, click into any service to compare tiers.</p>
          </div>

          {loading ? (
            <div className="text-center text-gray-500 py-16">Loading pricing…</div>
          ) : (
            <div className="rounded-2xl border border-gray-200 bg-white overflow-hidden">
              {orderedSlugs.map((slug, i) => {
                const s = services[slug];
                const essential = s.tiers[0];
                return (
                  <Link
                    key={slug}
                    to={`/systems/solutions/${slug}/pricing`}
                    data-testid={`all-pricing-row-${slug}`}
                    className={`flex items-center gap-5 p-5 md:p-6 hover:bg-[#FEFBF3] transition ${i !== 0 ? 'border-t border-gray-100' : ''}`}
                  >
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        <div className="text-[10px] font-extrabold uppercase tracking-[0.18em] text-gray-400">{s.category}</div>
                        {s.popular && <span className="px-1.5 py-0.5 rounded-full bg-[#f5a623] text-black text-[9px] font-extrabold tracking-[0.14em]">POPULAR</span>}
                      </div>
                      <div className="text-base md:text-lg font-bold text-gray-900 truncate">{s.name}</div>
                      <p className="text-[13px] text-gray-500 mt-1 line-clamp-1">{s.tagline}</p>
                    </div>
                    <div className="text-right flex-shrink-0">
                      <div className="text-[11px] text-gray-500">from</div>
                      <div className="text-xl md:text-2xl font-extrabold text-gray-900">{format(Math.round(essential.price))}</div>
                      <div className="text-[11px] text-gray-500">/{s.unit}</div>
                    </div>
                    <ArrowRight className="w-5 h-5 text-gray-400 hidden md:block flex-shrink-0" />
                  </Link>
                );
              })}
            </div>
          )}

          <div className="mt-14 text-center">
            <p className="text-gray-600">Need something outside these tiers?</p>
            <Link to="/systems/contact" className="mt-3 inline-block px-6 py-3 rounded-full bg-[#f5a623] text-[#0e0e10] text-[13px] font-semibold uppercase tracking-wider hover:brightness-105 transition">Talk to sales</Link>
          </div>
        </div>
      </main>
      <SystemsFooter />
    </div>
  );
}
